import styled from "@emotion/styled";
import bgImage from "../../assets/bgImage.png";

const LoginStyle = styled.div({
  background: `url(${bgImage})`,
  padding: 0,
  margin: 0,
  maxWidth: "100vw",
  height: "100vh",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundAttachment: "fixed",
  backgroundPosition: "center center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  "& .Container": {
    borderRadius: "6px",
    backgroundColor: "white",
    width: "450px",
    Height: "550px",
  },
  "& img": {},
  "& a": {
    color: "unset",
  },
  "& a:hover": {
    color: "#1890ff",
  },
  "& form": {
    padding: "10px 0",
    "& .ant-form-item-label>label.ant-form-item-required:not(.ant-form-item-required-mark-optional):before":
      {
        content: "none",
      },
  },
  "& .fileds": {
    "& .ant-form-item-explain-connected": {
      width: "unset",
    },
  },
  "& .ant-input::placeholder": {
    fontWeight: "400",
    fontSize: "16px",
  },
  "& .ant-btn-primary": {
    borderColor: "#244DA0",
  },
});

export default LoginStyle;
